var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { ifProp, getTypography } from '@creditas-ui/utilities';
import { Typography } from '@creditas-ui/typography';
import { styled, css } from '@creditas-ui/system';

var disabled = _ref => {
  var {
    theme: {
      tag
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), tag('disabled.text.color'));
};

var base = _ref2 => {
  var {
    theme: {
      tag
    }
  } = _ref2;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), tag('base.text.color'));
};

export var Label = styled(Typography)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), ifProp({
  size: 'medium'
}, getTypography('bodyMdRegular')), base, ifProp('disabled', disabled));
//# sourceMappingURL=Label.styles.js.map